<div class="personal-information-form">
  <div class="col-sm-12 p-0 mb-4">
    <div class="row align-items-center pb-2 mb-3">
      <div class="col-auto">
        <span class="text-muted text-xs"
          >Step
          <span v-if="collapsed_sections.applicant_details">1</span>
          <span v-if="collapsed_sections.personal_information">2</span>
          <span v-if="collapsed_sections.residential_information">3</span>
          <span v-if="collapsed_sections.relative_information">4</span>
          of 4</span
        >
      </div>
      <div class="col-auto">
        <span class="text-secondary text-xs">|</span>
      </div>
      <div class="col">
        <span class="fs-6 text-dark" v-if="collapsed_sections.applicant_details"
          >Applicant Details</span
        >
        <span
          class="fs-6 text-dark"
          v-if="collapsed_sections.personal_information"
          >Additional Information</span
        >
        <span
          class="fs-6 text-dark"
          v-if="collapsed_sections.residential_information"
          >Residential Information</span
        >
        <span
          class="fs-6 text-dark"
          v-if="collapsed_sections.relative_information"
          >Relative Information</span
        >
      </div>
    </div>

    <!-- Applicant Details Section -->
    <transition name="fade">
      <div v-if="collapsed_sections.applicant_details">
        <!-- Admin only fields -->
        <div class="form-group my-2">
          <label for="customer-first-name" class="text-xs required"
            >First Name</label
          >
          <input
            type="text"
            id="customer-first-name"
            class="form-control"
            v-model="form_data.customerFirstName"
            placeholder="Enter your first name"
          />
        </div>

        <div class="form-group my-2">
          <label for="customer-middle-name" class="text-xs"
            >Middle Name(s)</label
          >
          <input
            type="text"
            id="customer-middle-name"
            class="form-control"
            v-model="form_data.customerMiddleName"
            placeholder="Enter your middle name(s)"
          />
        </div>

        <div class="form-group my-2">
          <label for="customer-surname" class="text-xs required">Surname</label>
          <input
            type="text"
            id="customer-surname"
            class="form-control"
            v-model="form_data.customerSurname"
            placeholder="Enter your surname"
            required
          />
        </div>
        <div class="form-group my-2">
          <label for="customer-id-type" class="text-xs required">ID Type</label>
          <select
            id="customer-id-type"
            class="form-select"
            v-model="form_data.customerIdType"
          >
            <option value="" disabled selected>Select ID Type</option>
            <option value="South African Valid ID">
              South African Valid ID
            </option>
            <option value="Passport">Passport</option>
          </select>
        </div>
        <div class="form-group my-2">
          <label for="customer-id-number" class="text-xs required"
            >{{ form_data.customerIdType === 'Passport' ? 'Passport Number' :
            'ID Number' }}</label
          >
          <input
            type="text"
            id="customer-id-number"
            class="form-control"
            v-model="form_data.customerIdNumber"
            :placeholder="form_data.customerIdType === 'Passport' ? 'Enter your passport number' : 'Enter your ID number (13 digits for SA ID)'"
            required
          />
        </div>

        <div class="form-group my-2">
          <label for="customer-date-of-birth" class="text-xs required"
            >Date of Birth</label
          >
          <input
            type="text"
            maxlength="8"
            @input="allow_num"
            id="customer-date-of-birth"
            class="form-control required"
            v-model="form_data.customerDateOfBirth"
            placeholder="YYYYMMDD"
          />
        </div>

        <!-- Passport information section (only displayed when Passport is selected as ID type) -->
        <div
          v-if="form_data.customerIdType === 'Passport'"
          class="passport-information mt-2 border-start border-2 ps-3 mb-3"
        >
          <h6 class="mb-2">Passport Information</h6>
          <PassPort
            :passport_data="form_data.passport_details"
            :countries="countries"
          />
        </div>
      </div>
    </transition>

    <!-- Personal Information Section -->
    <transition name="fade">
      <div v-if="collapsed_sections.personal_information">
        <div class="form-group my-2">
          <label class="text-xs mb-2 d-block">Preferred Language</label>
          <div class="d-flex flex-column">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="preferred-language-english"
                value="English"
                v-model="form_data.customerPreferredLanguage"
              />
              <label
                class="form-check-label text-xs"
                for="preferred-language-english"
                >English</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="preferred-language-afrikaans"
                value="Afrikaans"
                v-model="form_data.customerPreferredLanguage"
              />
              <label
                class="form-check-label text-xs"
                for="preferred-language-afrikaans"
                >Afrikaans</label
              >
            </div>
          </div>
        </div>

        <div class="form-group my-2">
          <label class="text-xs mb-2 d-block required">Gender</label>
          <div class="d-flex flex-column" id='customer-gender'>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="gender-not-selected"
                value="Not Selected"
                v-model="form_data.customerGender"
              />
              <label class="form-check-label text-xs" for="gender-not-selected"
                >Not Selected</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="gender-male"
                value="Male"
                v-model="form_data.customerGender"
              />
              <label class="form-check-label text-xs" for="gender-male"
                >Male</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="gender-female"
                value="Female"
                v-model="form_data.customerGender"
              />
              <label class="form-check-label text-xs" for="gender-female"
                >Female</label
              >
            </div>
          </div>
        </div>

        <div class="form-group my-2">
          <label for="customer-title" class="text-xs required">Title</label>
          <select
            id="customer-title"
            class="form-select"
            v-model="form_data.customerTitle"
          >
            <option value="Not Selected">Not Selected</option>
            <option value="Advocate">Advocate</option>
            <option value="Doctor">Doctor</option>
            <option value="Mr">Mr</option>
            <option value="Miss">Miss</option>
            <option value="Mrs">Mrs</option>
            <option value="Reverend">Reverend</option>
            <option value="Professor">Professor</option>
          </select>
        </div>

        <div class="form-group my-2">
          <label for="customer-race-ethnic-group" class="text-xs required"
            >Race/Ethnic Group</label
          >
          <select
            id="customer-race-ethnic-group"
            class="form-select"
            v-model="form_data.customerRaceEthnicGroup"
          >
            <option value="Not Selected">Not Selected</option>
            <option value="Asian">Asian</option>
            <option value="Black">Black</option>
            <option value="Coloured">Coloured</option>
            <option value="White">White</option>
          </select>
        </div>

        <div class="form-group my-2">
          <label for="customer-nationality" class="text-xs required">Country of Nationality</label>
          <select
            id="customer-nationality"
            class="form-select"
            v-model="form_data.customerNationality"
          >
            <option value="" disabled selected>Select Nationality</option>
            <option
              v-for="(country, index) in countries"
              :key="index"
              :value="country"
            >
              {{ country }}
            </option>
          </select>
        </div>

        <div class="form-group my-2">
          <label class="text-xs mb-2 d-block">Are you a graduate?</label>
          <div class="d-flex flex-column">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="customer-graduate-yes"
                value="Yes"
                v-model="form_data.customerGraduate"
              />
              <label
                class="form-check-label text-xs"
                for="customer-graduate-yes"
                >Yes</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="customer-graduate-no"
                value="No"
                v-model="form_data.customerGraduate"
              />
              <label class="form-check-label text-xs" for="customer-graduate-no"
                >No</label
              >
            </div>
          </div>
        </div>

        <div class="form-group my-2">
          <label for="customer-level-of-education" class="text-xs"
            >What is your level of education?</label
          >
          <select
            id="customer-level-of-education"
            class="form-select"
            v-model="form_data.customerLevelOfEducation"
          >
            <option value="Not Selected">Not Selected</option>
            <option value="PRIMARY SCHOOL">PRIMARY SCHOOL</option>
            <option value="SOME HIGH SCHOOL">SOME HIGH SCHOOL</option>
            <option value="COMPLETED MATRIC">COMPLETED MATRIC</option>
            <option value="DIPLOMA">DIPLOMA</option>
            <option value="BACHELORS DEGREE">BACHELORS DEGREE</option>
            <option value="HONOURS OR HIGHER">HONOURS OR HIGHER</option>
          </select>
        </div>

        <div class="form-group my-2">
          <label for="customer-marital-status" class="text-xs required"
            >Marital Status</label
          >
          <select
            id="customer-marital-status"
            class="form-select"
            v-model="form_data.customerMaritalStatus"
            required
          >
            <option value="Not Selected">Not Selected</option>
            <option value="Divorced">Divorced</option>
            <option value="Married">Married</option>
            <option value="Single">Single</option>
            <option value="Widow/er">Widow/er</option>
          </select>
        </div>

        <div
          class="form-group my-2"
          v-if="form_data.customerMaritalStatus === 'Married'"
        >
          <label for="customer-marital-contract" class="text-xs"
            >Marital Contract Type</label
          >
          <select
            id="customer-marital-contract"
            class="form-select"
            v-model="form_data.customerMaritalContract"
          >
            <option value="" disabled selected>Select Contract Type</option>
            <option value="Antenuptual Contract">Antenuptual Contract</option>
            <option value="In Community of property">
              In Community of property
            </option>
            <option value="Traditional Marriage">Traditional Marriage</option>
            <option value="Married in COP (Chapter 2 & 3)">
              Married in COP (Chapter 2 & 3)
            </option>
            <option value="Married in COP (not Chapter 2 & 3)">
              Married in COP (not Chapter 2 & 3)
            </option>
            <option value="Foreign/Custom">Foreign/Custom</option>
          </select>
        </div>

        <div
          class="form-group my-2"
          v-if="form_data.customerMaritalStatus === 'Married'"
        >
          <label for="date-married" class="text-xs">Date of Marriage</label>
          <input
            type="text"
            maxlength="8"
            @input="allow_num"
            id="date-married"
            class="form-control"
            v-model="form_data.dateMarried"
            placeholder="YYYYMMDD"
          />
        </div>

        <!-- Spouse details section styled like Passport -->
        <div
          v-if="form_data.customerMaritalStatus === 'Married'"
          class="spouse-information mt-2 border-start border-2 ps-3 mb-3"
        >
          <h6 class="mb-2">Spouse Details</h6>
          <SpouseDetail :spouse_data="form_data.spouse_details" />
        </div>
        <div class="form-group my-2">
          <label for="customer-preferred-contact-method" class="text-xs required"
            >Preferred Contact Method</label
          >
          <select
            id="customer-preferred-contact-method"
            class="form-select"
            v-model="form_data.customerPreferredContactMethod"
          >
            <option value="Not Selected">Not Selected</option>
            <option value="Cell phone">Cell phone</option>
            <option value="Email">Email</option>
            <option value="Home phone">Home phone</option>
            <option value="Postal">Postal</option>
            <option value="Work phone">Work phone</option>
          </select>
        </div>

        <div class="form-group my-2">
          <label
            for="customer-mobile-phone-number"
            class="text-xs required"
            >Mobile Phone Number</label
          >
          <input
            type="text"
            id="customer-mobile-phone-number"
            class="form-control"
            v-model="form_data.customerMobilePhoneNumber"
            placeholder="Enter your mobile phone number"
            :required="form_data.customerPreferredContactMethod === 'Cellphone'"
          />
        </div>

        <div class="form-group my-2">
          <label class="text-xs mb-2 d-block">Mobile Phone Plan Type</label>
          <div class="d-flex flex-column">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="mobile-type-contract"
                value="Contract"
                v-model="form_data.mobileType"
              />
              <label class="form-check-label text-xs" for="mobile-type-contract"
                >Contract</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="mobile-type-payg"
                value="Pay-as-you-go"
                v-model="form_data.mobileType"
              />
              <label class="form-check-label text-xs" for="mobile-type-payg"
                >Pay-as-you-go</label
              >
            </div>
          </div>
        </div>

        <div class="form-group my-2">
          <label
            for="customer-home-phone-number"
            class="text-xs required"
            >Home Phone Number</label
          >
          <input
            type="text"
            id="customer-home-phone-number"
            class="form-control"
            v-model="form_data.customerHomePhoneNumber"
            placeholder="Enter your home phone number"
            :required="form_data.customerPreferredContactMethod === 'Home'"
          />
        </div>

        <div class="form-group my-2">
          <label class="text-xs mb-2 d-block">Work Phone Number Type</label>
          <div class="d-flex flex-column">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="work-phone-type-landline"
                value="Land line"
                v-model="form_data.customerWorkPhoneNumberType"
              />
              <label
                class="form-check-label text-xs"
                for="work-phone-type-landline"
                >Land line</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="work-phone-type-cell"
                value="Cell"
                v-model="form_data.customerWorkPhoneNumberType"
              />
              <label class="form-check-label text-xs" for="work-phone-type-cell"
                >Cell</label
              >
            </div>
          </div>
        </div>

        <div class="form-group my-2">
          <label
            for="customer-work-phone-number"
            class="text-xs required"
            >Work Phone Number</label
          >
          <input
            type="text"
            id="customer-work-phone-number"
            class="form-control"
            v-model="form_data.customerWorkPhoneNumber"
            placeholder="Enter your work phone number"
            :required="form_data.customerPreferredContactMethod === 'Work'"
          />
        </div>

        <div class="form-group my-2">
          <label for="customer-email" class="text-xs required">Email Address</label>
          <input
            type="email"
            id="customer-email"
            class="form-control"
            v-model="form_data.customerEmail"
            placeholder="Enter your email address"
          />
        </div>
        <div class="form-group my-2">
          <label for="country-of-birth" class="text-xs required">Country of Birth</label>
          <select
            id="country-of-birth"
            class="form-select"
            v-model="form_data.countryOfBirth"
          >
            <option value="" disabled selected>Select Country of Birth</option>
            <option
              v-for="(country, index) in countries"
              :key="index"
              :value="country"
            >
              {{ country }}
            </option>
          </select>
        </div>

        <div class="form-group my-2">
          <label class="text-xs mb-2 d-block"
            >Do you have any foreign birthplace, nationality, citizenship or tax
            obligation?</label
          >
          <div class="d-flex flex-column">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="is-foreign-or-tax-obligation-not-selected"
                value="Not Selected"
                v-model="form_data.isForeignOrTaxObligation"
              />
              <label
                class="form-check-label text-xs"
                for="is-foreign-or-tax-obligation-not-selected"
                >Not Selected</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="is-foreign-or-tax-obligation-yes"
                value="Yes"
                v-model="form_data.isForeignOrTaxObligation"
              />
              <label
                class="form-check-label text-xs"
                for="is-foreign-or-tax-obligation-yes"
                >Yes</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="is-foreign-or-tax-obligation-no"
                value="No"
                v-model="form_data.isForeignOrTaxObligation"
              />
              <label
                class="form-check-label text-xs"
                for="is-foreign-or-tax-obligation-no"
                >No</label
              >
            </div>
          </div>
        </div>

        <div class="form-group my-2">
          <label class="text-xs mb-2 d-block"
            >Do you have multiple nationalities?</label
          >
          <div class="d-flex flex-column">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="is-multiple-nationalities-not-selected"
                value="Not Selected"
                v-model="form_data.isMultipleNationalities"
              />
              <label
                class="form-check-label text-xs"
                for="is-multiple-nationalities-not-selected"
                >Not Selected</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="is-multiple-nationalities-yes"
                value="Yes"
                v-model="form_data.isMultipleNationalities"
              />
              <label
                class="form-check-label text-xs"
                for="is-multiple-nationalities-yes"
                >Yes</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="is-multiple-nationalities-no"
                value="No"
                v-model="form_data.isMultipleNationalities"
              />
              <label
                class="form-check-label text-xs"
                for="is-multiple-nationalities-no"
                >No</label
              >
            </div>
          </div>
        </div>

        <div class="form-group my-2">
          <label class="text-xs mb-2 d-block"
            >Were you ever a South African Citizen?</label
          >
          <div class="d-flex flex-column">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="was-south-african-citizen-not-selected"
                value="Not Selected"
                v-model="form_data.wasSouthAfricanCitizen"
              />
              <label
                class="form-check-label text-xs"
                for="was-south-african-citizen-not-selected"
                >Not Selected</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="was-south-african-citizen-yes"
                value="Yes"
                v-model="form_data.wasSouthAfricanCitizen"
              />
              <label
                class="form-check-label text-xs"
                for="was-south-african-citizen-yes"
                >Yes</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="was-south-african-citizen-no"
                value="No"
                v-model="form_data.wasSouthAfricanCitizen"
              />
              <label
                class="form-check-label text-xs"
                for="was-south-african-citizen-no"
                >No</label
              >
            </div>
          </div>
        </div>

        <div class="form-group my-2">
          <label for="country-citizenship" class="text-xs"
            >Country of Citizenship?</label
          >
          <select
            id="country-citizenship"
            class="form-select"
            v-model="form_data.countryCitizenship"
          >
            <option value="" disabled selected>
              Select Country of Citizenship
            </option>
            <option
              v-for="(country, index) in countries"
              :key="index"
              :value="country"
            >
              {{ country }}
            </option>
          </select>
        </div>

        <div class="form-group my-2">
          <label for="residential-address-country" class="text-xs"
            >Country of Residential Address</label
          >
          <select
            id="residential-address-country"
            class="form-select"
            v-model="form_data.residentialAddressCountry"
          >
            <option value="" disabled selected>
              Select Country of Residential Address
            </option>
            <option
              v-for="(country, index) in countries"
              :key="index"
              :value="country"
            >
              {{ country }}
            </option>
          </select>
        </div>
      </div>
    </transition>

    <!-- Residential Information Section -->
    <transition name="fade">
      <div v-if="collapsed_sections.residential_information">
        <div class="form-group my-2">
          <label
            for="customer-residential-address-line1"
            class="text-xs required"
            >Residential Address Line 1</label
          >
          <input
            type="text"
            id="customer-residential-address-line1"
            class="form-control"
            v-model="form_data.customerResidentialAddressLine1"
            placeholder="Enter residential address line 1"
            required
          />
        </div>

        <div class="form-group my-2">
          <label for="customer-residential-address-suburb" class="text-xs required"
            >Residential Suburb</label
          >
          <input
            type="text"
            id="customer-residential-address-suburb"
            class="form-control"
            v-model="form_data.customerResidentialAddressSuburb"
            placeholder="Enter residential suburb"
          />
        </div>

        <div class="form-group my-2">
          <label for="customer-residential-address-city" class="text-xs required"
            >Residential City/Town</label
          >
          <input
            type="text"
            id="customer-residential-address-city"
            class="form-control"
            v-model="form_data.customerResidentialAddressCity"
            placeholder="Enter residential city or town"
          />
        </div>

        <div class="form-group my-2">
          <label for="customer-residential-address-postal-code" class="text-xs required"
            >Residential Postal Code</label
          >
          <input
            type="text"
            id="customer-residential-address-postal-code"
            class="form-control"
            v-model="form_data.customerResidentialAddressPostalCode"
            placeholder="Enter residential postal code"
          />
        </div>
        <div class="form-group my-2">
          <label class="text-xs mb-2 d-block"
            >Is Postal Address Same as Residential?</label
          >
          <div class="d-flex flex-column">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="same-as-res-not-selected"
                value="Not Selected"
                v-model="form_data.sameAsRes"
              />
              <label
                class="form-check-label text-xs"
                for="same-as-res-not-selected"
                >Not Selected</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="same-as-res-use-address-below"
                value="Use Address Below"
                v-model="form_data.sameAsRes"
              />
              <label
                class="form-check-label text-xs"
                for="same-as-res-use-address-below"
                >Enter Postal Address</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="same-as-res-use-residential-address"
                value="Use Residential Address"
                v-model="form_data.sameAsRes"
              />
              <label
                class="form-check-label text-xs"
                for="same-as-res-use-residential-address"
                >Use Residential Address</label
              >
            </div>
          </div>
        </div>

        <div v-if="form_data.sameAsRes === 'Use Address Below'">
          <div class="form-group my-2">
            <label for="customer-postal-address-line1" class="text-xs"
              >Postal Address Line 1</label
            >
            <input
              type="text"
              id="customer-postal-address-line1"
              class="form-control"
              v-model="form_data.customerPostalAddressLine1"
              placeholder="Enter postal address line 1 (PO Box)"
            />
          </div>

          <div class="form-group my-2">
            <label for="customer-postal-address-suburb" class="text-xs"
              >Postal Suburb</label
            >
            <input
              type="text"
              id="customer-postal-address-suburb"
              class="form-control"
              v-model="form_data.customerPostalAddressSuburb"
              placeholder="Enter postal suburb"
            />
          </div>

          <div class="form-group my-2">
            <label for="customer-postal-address-city" class="text-xs"
              >Postal City/Town</label
            >
            <input
              type="text"
              id="customer-postal-address-city"
              class="form-control"
              v-model="form_data.customerPostalAddressCity"
              placeholder="Enter postal city or town"
            />
          </div>

          <div class="form-group my-2">
            <label for="customer-postal-address-postal-code" class="text-xs"
              >Postal Code</label
            >
            <input
              type="text"
              id="customer-postal-address-postal-code"
              class="form-control"
              v-model="form_data.customerPostalAddressPostalCode"
              placeholder="Enter postal code"
            />
          </div>
        </div>

        <div class="form-group my-2">
          <label for="owner-tenant-lodger" class="text-xs required"
            >Owner/Tenant/Lodger Status</label
          >
          <select
            id="owner-tenant-lodger"
            class="form-select"
            v-model="form_data.ownerTenantLodger"
            required
          >
            <option value="" disabled selected>Select Status</option>
            <option value="Owner - Bonded">Owner - Bonded</option>
            <option value="Owner - Bond Free">Owner - Bond Free</option>
            <option value="Tenant">Tenant</option>
            <option value="Lodger">Lodger</option>
          </select>
        </div>

        <div
          class="form-group my-2"
          v-if="['Owner - Bonded'].includes(form_data.ownerTenantLodger)"
        >
          <label for="outstanding-bond-balance" class="text-xs required"
            >Outstanding Bond Balance</label
          >
          <input
            type="number"
            id="outstanding-bond-balance"
            class="form-control"
            v-model="form_data.outstandingBondBalance"
            placeholder="Enter outstanding bond balance"
            required
          />
        </div>

        <div
          class="form-group my-2"
          v-if="['Owner - Bonded'].includes(form_data.ownerTenantLodger)"
        >
          <label for="joint-homeloan-indicator" class="text-xs"
            >Is this a joint bond?</label
          >
          <select
            id="joint-homeloan-indicator"
            class="form-select"
            v-model="form_data.jointHomeloanIndicator"
          >
            <option value="" disabled selected>Select Option</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>

        <div
          class="form-group my-2"
          v-if="form_data.jointHomeloanIndicator === 'Yes'"
        >
          <label for="joint-bond-percentage" class="text-xs"
            >Joint Bond Percentage</label
          >
          <input
            type="number"
            id="joint-bond-percentage"
            class="form-control"
            v-model="form_data.jointBondPercentage"
            placeholder="Enter percentage (0.00-100.00)"
            step="0.01"
            min="0"
            max="100"
          />
        </div>

        <div class="form-group my-2">
          <label for="residential-owner" class="text-xs required"
            >Residence Owner</label
          >
          <select
            id="residential-owner"
            class="form-select"
            v-model="form_data.residentialOwner"
            required
          >
            <option value="Not Selected">Not Selected</option>
            <option value="Self">Self</option>
            <option value="Both">Both</option>
            <option value="Spouse">Spouse</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div
          class="form-group my-2"
          v-if="['Owner - Bonded', 'Owner - Bond Free'].includes(form_data.ownerTenantLodger)"
        >
          <label for="facility-value" class="text-xs">Facility Value</label>
          <input
            type="number"
            id="facility-value"
            class="form-control"
            v-model="form_data.facilityValue"
            placeholder="Enter facility value"
          />
        </div>

        <div
          class="form-group my-2"
          v-if="['Owner - Bonded', 'Owner - Bond Free'].includes(form_data.ownerTenantLodger)"
        >
          <label for="property-current-value" class="text-xs"
            >Current Property Value</label
          >
          <input
            type="number"
            id="property-current-value"
            class="form-control"
            v-model="form_data.propertyCurrentValue"
            placeholder="Enter current property value"
          />
        </div>

        <div
          class="form-group my-2"
          v-if="['Owner - Bonded'].includes(form_data.ownerTenantLodger)"
        >
          <label for="bond-lenders" class="text-xs">Bond Lender</label>
          <select
            id="bond-lenders"
            class="form-select"
            v-model="form_data.bondLenders"
          >
            <option value="Not Selected">Not Selected</option>
            <option
              v-for="(lender, index) in bond_lenders_list"
              :key="index"
              :value="lender"
            >
              {{ lender }}
            </option>
          </select>
        </div>
        <div class="form-group my-2">
          <label class="text-xs required">How long at Current Address?</label>
          <div class="d-flex">
            <input
              type="number"
              class="form-control me-2"
              v-model="form_data.customerPeriodAtCurrentAddressYears"
              placeholder="Years"
              id="customer-period-at-current-address-years"
              min="0"
              required
            />
            <input
              type="number"
              class="form-control"
              v-model="form_data.customerPeriodAtCurrentAddressMonths"
              placeholder="Months"
              id="customer-period-at-current-address-months"
              min="0"
              max="11"
            />
          </div>
          <small class="text-muted text-xs">
            {{ form_data.customerPeriodAtCurrentAddressYears || 0 }} Years and
            {{ form_data.customerPeriodAtCurrentAddressMonths || 0 }} Months
          </small>
        </div>
        <div class="form-group my-2">
          <label class="text-xs">How long at Previous Address?</label>
          <div class="d-flex">
            <input
              type="number"
              id="customer-period-at-previous-address-years"
              class="form-control me-2"
              v-model="form_data.customerPeriodAtPreviousAddressYears"
              placeholder="Years"
              min="0"
            />
            <input
              type="number"
              class="form-control"
              id="customer-period-at-previous-address-months"
              v-model="form_data.customerPeriodAtPreviousAddressMonths"
              placeholder="Months"
              min="0"
              max="11"
            />
          </div>
          <small class="text-muted text-xs">
            {{ form_data.customerPeriodAtPreviousAddressYears || 0 }} Years and
            {{ form_data.customerPeriodAtPreviousAddressMonths || 0 }} Months
          </small>
        </div>
      </div>
    </transition>

    <!-- Relative Information Section -->
    <transition name="fade">
      <div v-if="collapsed_sections.relative_information">
        <div class="form-group my-2">
          <label for="relative-first-names" class="text-xs"
            >What are the relative's first names?</label
          >
          <input
            type="text"
            id="relative-first-names"
            class="form-control"
            v-model="form_data.relativeFirstNames"
            placeholder="Enter relative's first names"
          />
        </div>
        <div class="form-group my-2">
          <label for="relative-surname" class="text-xs"
            >What is the relative's surname?</label
          >
          <input
            type="text"
            id="relative-surname"
            class="form-control"
            v-model="form_data.relativeSurname"
            placeholder="Enter relative's surname"
          />
        </div>
        <div class="form-group my-2">
          <label for="relative-relation" class="text-xs"
            >What is the relation to the relative?</label
          >
          <select
            id="relative-relation"
            class="form-select"
            v-model="form_data.relativeRelation"
          >
            <option value="Not Selected">Not Selected</option>
            <option>Aunt</option>
            <option>Brother</option>
            <option>Brother in Law</option>
            <option>Cousin</option>
            <option>Daughter</option>
            <option>Father</option>
            <option>Father in Law</option>
            <option>Friend</option>
            <option>Grandfather</option>
            <option>Grandmother</option>
            <option>Husband</option>
            <option>Mother</option>
            <option>Mother in Law</option>
            <option>Sister</option>
            <option>Sister in Law</option>
            <option>Son</option>
            <option>Uncle</option>
            <option>Wife</option>
          </select>
        </div>
        <div class="form-group my-2">
          <label class="text-xs mb-2 d-block"
            >What is the relative's preferred contact method?</label
          >
          <div class="d-flex flex-column">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="relative-preferred-contact-method-not-selected"
                value="Not Selected"
                v-model="form_data.relativePreferredContactMethod"
              />
              <label
                class="form-check-label text-xs"
                for="relative-preferred-contact-method-not-selected"
                >Not Selected</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="relative-preferred-contact-method-cellphone"
                value="Cellphone"
                v-model="form_data.relativePreferredContactMethod"
              />
              <label
                class="form-check-label text-xs"
                for="relative-preferred-contact-method-cellphone"
                >Cellphone</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="relative-preferred-contact-method-home"
                value="Home"
                v-model="form_data.relativePreferredContactMethod"
              />
              <label
                class="form-check-label text-xs"
                for="relative-preferred-contact-method-home"
                >Home</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="relative-preferred-contact-method-work"
                value="Work"
                v-model="form_data.relativePreferredContactMethod"
              />
              <label
                class="form-check-label text-xs"
                for="relative-preferred-contact-method-work"
                >Work</label
              >
            </div>
          </div>
        </div>
        <div class="form-group my-2">
          <label for="relative-cellphone" class="text-xs"
            >What is the relative's cellphone number?</label
          >
          <input
            type="text"
            id="relative-cellphone"
            class="form-control"
            v-model="form_data.relativeCellphone"
            placeholder="Enter relative's cellphone number"
          />
        </div>
        <div class="form-group my-2">
          <label for="relative-home-phone-number" class="text-xs"
            >What is the relative's home phone number?</label
          >
          <input
            type="text"
            id="relative-home-phone-number"
            class="form-control"
            v-model="form_data.relativePhoneNumber"
            placeholder="Enter relative's home phone number"
          />
        </div>
        <div class="form-group my-2">
          <label for="relative-work-phone-number" class="text-xs"
            >What is the relative's work phone number?</label
          >
          <input
            type="text"
            id="relative-work-phone-number"
            class="form-control"
            v-model="form_data.relativeWorkNumber"
            placeholder="Enter relative's work phone number"
          />
        </div>
        <div class="form-group my-2">
          <label for="relative-address-line1" class="text-xs"
            >What is the relative's address line 1?</label
          >
          <input
            type="text"
            id="relative-address-line1"
            class="form-control"
            v-model="form_data.relativeAddressLine1"
            placeholder="Enter relative's address line 1"
          />
        </div>
        <div class="form-group my-2">
          <label for="relative-address-line2" class="text-xs"
            >What is the relative's address line 2?</label
          >
          <input
            type="text"
            id="relative-address-line2"
            class="form-control"
            v-model="form_data.relativeAddressLine2"
            placeholder="Enter relative's address line 2"
          />
        </div>
        <div class="form-group my-2">
          <label for="relative-address-suburb" class="text-xs"
            >What is the relative's suburb?</label
          >
          <input
            type="text"
            id="relative-address-suburb"
            class="form-control"
            v-model="form_data.relativeAddressSuburb"
            placeholder="Enter relative's suburb"
          />
        </div>
        <div class="form-group my-2">
          <label for="relative-address-city" class="text-xs"
            >What is the relative's city?</label
          >
          <input
            type="text"
            id="relative-address-city"
            class="form-control"
            v-model="form_data.relativeAddressCity"
            placeholder="Enter relative's city"
          />
        </div>
        <div class="form-group my-2">
          <label for="relative-address-postal-code" class="text-xs"
            >What is the relative's postal code?</label
          >
          <input
            type="text"
            id="relative-address-postal-code"
            class="form-control"
            v-model="form_data.relativeAddressPostalCode"
            placeholder="Enter relative's postal code"
          />
        </div>
      </div>
    </transition>
  </div>
  <div class="text-end mt-4">
    <button
      v-if="!collapsed_sections.applicant_details"
      type="button"
      @click="go_to_previous_section"
      class="btn btn-bg-secondary text-xs rounded-small me-2"
    >
      Previous
    </button>
    <button
      v-if="!collapsed_sections.relative_information"
      type="button"
      @click="go_to_next_section"
      class="btn btn-bg-green text-xs rounded-small shadow-sm"
    >
      Next
    </button>
    <button
      v-if="collapsed_sections.relative_information"
      type="button"
      @click="submit_section"
      class="btn btn-bg-green text-xs rounded-small shadow-sm"
    >
      Continue
    </button>
  </div>
</div>
